import React from 'react';
import Card from './Card';
import {Box, Typography} from "@mui/material";
import publ1 from '../../img/publ_1.png';
import publ2 from '../../img/publ_2.png';
import publ3 from '../../img/publ_3.png';
import publ4 from '../../img/publ_4.png';
import publ5 from '../../img/publ_5.png';
import publ6 from '../../img/publ_6.png';
import publ7 from '../../img/publ_7.png';
import publ8 from '../../img/publ_8.png';

function Publications({innerRef}) {
    const publications = [
        {
            imagePath: publ6,  // Percorso dell'immagine
            title: 'Context-Gated Cross-Modal Perception with Visual Mamba for PET-CT Lung Tumor Segmentation',  // Titolo della pubblicazione
            authors: 'Elena Mulero Ayllón, Linlin Shen, Pierangelo Veltri, Fabrizia Gelardi, Arturo Chiti, Paolo Soda, Matteo Tortora',  // Autori della pubblicazione
            links: [
                {url: 'https://arxiv.org/abs/2510.27508', label: 'arXiv, 2025'},
                {url: 'https://github.com/arco-group/vMambaX', label: 'GitHub'}
            ]
        },
        {
            imagePath: publ7,  // Percorso dell'immagine
            title: 'Can Foundation Models Really Segment Tumors? A Benchmarking Odyssey in Lung CT Imaging',  // Titolo della pubblicazione
            authors: 'Elena Mulero Ayllón, Massimiliano Mantegna, Linlin Shen, Paolo Soda, Valerio Guarrasi, Matteo Tortora',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://ieeexplore.ieee.org/abstract/document/11058743',
                    label: 'CBMS, 2025'
                },
            ]
        },
        {
            imagePath: publ8,  // Percorso dell'immagine
            title: 'Machine learning predicts pulmonary Long Covid sequelae using clinical data',  // Titolo della pubblicazione
            authors: 'Ermanno Cordelli, Paolo Soda, Sara Citter, Elia Schiavon, Christian Salvatore, Deborah Fazzini, Greta Clementi, Michaela Cellina, Andrea Cozzi, Chandra Bortolotto, Lorenzo Preda, Luisa Francini, Matteo Tortora, Isabella Castiglioni, Sergio Papa, Diego Sona, Marco Alì',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://link.springer.com/article/10.1186/s12911-024-02745-33',
                    label: 'BMC Medical Informatics and Decision Making, 2024'
                },
            ]
        },
        {
            imagePath: publ1,  // Percorso dell'immagine
            title: 'Deep Reinforcement Learning for Fractionated Radiotherapy in Non-Small Cell Lung Carcinoma',  // Titolo della pubblicazione
            authors: 'Matteo Tortora,  Ermanno Cordelli,  Rosa Sicilia,  Marianna Miele,  Paolo Matteucci,  Giulio Iannello,  Sara Ramella,  Paolo Soda',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://www.sciencedirect.com/science/article/abs/pii/S0933365721001305#preview-section-abstract',
                    label: 'Artificial Intelligence in Medicine, 2021'
                },
            ]
        },
        {
            imagePath: publ2,
            title: 'RadioPathomics: multimodal learning in non-small cell lung cancer for adaptive radiotherapy',

            authors: 'Matteo Tortora, Ermanno Cordelli, Rosa Sicilia, Lorenzo Nibid, Edy Ippolito, Giuseppe Perrone, Sara Ramella, Paolo Soda',
            links: [
                {url: 'https://ieeexplore.ieee.org/abstract/document/10122541/', label: 'IEEE Access, 2023'}
            ]
        },
        {
            imagePath: publ3,
            title: 'PyTrack: a Map-Matching-based Python Toolbox for Vehicle Trajectory Reconstruction',

            authors: 'Matteo Tortora, Ermanno Cordelli, Paolo Soda',
            links: [
                {url: 'https://ieeexplore.ieee.org/abstract/document/9927417/', label: 'IEEE Access, 2022'},
                {url: 'https://github.com/cosbidev/PyTrack', label: 'GitHub'}
            ]
        },
        {
            imagePath: publ4,
            title: 'MATNet: Multi-Level Fusion Transformer-Based Model for Day-Ahead PV Generation Forecasting',

            authors: 'Matteo Tortora, Francesco Conte, Gianluca Natrella, Paolo Soda',
            links: [
                {url: 'https://scholar.google.com/scholar?oi=bibs&cluster=2439803367656401650&btnI=1&hl=it', label: 'arXiv, 2023'},
            ]
        },
    {
            imagePath: publ5,
            title: 'Exploring Early Stress Detection from Multimodal Time Series with Deep Reinforcement Learning',

            authors: 'Leonardo Furia, Matteo Tortora, Paolo Soda, Rosa Sicilia',
            links: [
                {url: 'https://ieeexplore.ieee.org/abstract/document/10385549/', label: 'BIBM, 2023'},
            ]
        }
    ];

    return (
        <Box ref={innerRef} display="flex" flexDirection="column" alignItems="center" mt={4} id={"publications"}>
            <Typography variant="body1" sx={{fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto'}} mb={2}>
                A complete and up-to-date list of publications can be found on <a
                href="https://scholar.google.com/citations?user=3WpZse0AAAAJ" target="_blank" rel="noopener noreferrer"
                style={{color: "#793eee", textDecoration: "none"}}>Google Scholar</a>.
            </Typography>
            {publications.map((pub, index) => (
                <Card
                    key={index}
                    imagePath={pub.imagePath}
                    title={pub.title}
                    authors={pub.authors}
                    links={pub.links}
                />
            ))}
        </Box>
    );
}

export default Publications;
